<div class="ticker-block" *ngIf="tickerBlock">
  <app-ticker-block-item *ngFor="let image of tickerBlock.images" [imageUrl]="image.urls.default"
    [label]="image.caption" [loopImage]="tickerBlock.loopImage">
  </app-ticker-block-item>
</div>
